import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
	BreedingRhombusSpinner
} from 'epic-spinners'

export default {
	name: 'invalidurll',
	components: {
		VueElementLoading,
		BreedingRhombusSpinner
	},
	props: [],
	data() {
		return {}
	},
	computed: {

	},
	mounted() {

	},
	methods: {

	}
}


// WEBPACK FOOTER //
// ./src/views/components/invalidurll/invalidurll.component.js